var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("ckeditor", {
        ref: "editor",
        attrs: {
          config: _vm.editorConfig,
          editor: _vm.editor,
          name: _vm.name,
          value: _vm.value
        },
        on: { input: _vm.onInput, ready: _vm.onEditorReady }
      }),
      _c("div", { staticClass: "row justify-content-between" }, [
        _c("div", { staticClass: "col-md-6 text-left" }, [
          _vm.danger
            ? _c(
                "div",
                {
                  staticClass:
                    "con-text-validation span-text-validation-danger v-enter-to"
                },
                [
                  _c("span", { staticClass: "span-text-validation" }, [
                    _vm._v(" " + _vm._s(_vm.dangerText) + " ")
                  ])
                ]
              )
            : _vm._e()
        ]),
        _vm.withCounter
          ? _c("div", { staticClass: "col-md-6 text-right" }, [
              _c(
                "small",
                {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: "Contador de caracteres",
                      expression: "'Contador de caracteres'"
                    }
                  ],
                  class: {
                    "text-danger font-weight-bold":
                      _vm.lengthText > _vm.maxLength
                  }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.lengthText) +
                      "/" +
                      _vm._s(_vm.maxLength) +
                      " "
                  )
                ]
              )
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }